import { Typography, Divider, List, ListItem, ListItemButton, ListItemIcon } from "@mui/material";
import { useLocation } from "react-router-dom";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { CONFIG } from "../../Config"


const notShowProd = ["MTPO", "CAIT", "POBR", "A2ZBBPS", "YESBANKBBPS", "BBPS2", "PAYSPRINTBBPS",
    "CAIN", "CAIR", "CAIP", "CELLMONEYBBPS", "AEPS5", "AEPS3", "MPOS"]


const Drawer = ({ menuItems, onClickProduct, profileData, innerMenuItem }) => {


    const location = useLocation();

    return <>
        <div className="sidebarlogoContainer"> 
            <img className="brandLogo" alt="logo" src={CONFIG.NAVBAR_LOGO} />
            <Typography variant="h6" className="alignS-center navbarTitle">{CONFIG.NAVBAR_TITLE}</Typography>
        </div>
        <Divider className="devider" />
        <List>
            {menuItems?.length > 0 && menuItems.map((item) => {

                if (item.path !== "" && !notShowProd.includes(item.prod_code)) {
                    return <div key={item.id}>

                        <ListItem
                            className={location.pathname.includes(item.path) ? "selectedMenu" : 'unSelectedMenu'}
                            disablePadding onClick={() => onClickProduct(item)}
                        >
                            <ListItemButton >
                                <ListItemIcon className="" >

                                    {item.image_src ? <img width="28px" className="iconImg" src={item.image_src} /> : item.icon}

                                </ListItemIcon>

                                <span className="menuTitle" >{item.title} </span>

                            </ListItemButton>
                            {item.childrens && item.childrens.length > 0 && (
                                <>
                                    {
                                        item.selected ? <KeyboardArrowUpIcon variant="btnIcon" /> : <KeyboardArrowRightIcon variant="btnIcon" />
                                    }
                                </>
                            )}
                        </ListItem>

                        {item.childrens && item.childrens.length > 0 && (
                            <>
                                {
                                    item.selected && item.childrens.map((subItem, _inner) => subItem.user_role?.includes(profileData.role_name) && (<ListItem key={subItem.id}
                                        className={location.pathname.includes(subItem.path) ? "selectedSubMenu" : 'unSelectedSubMenu'}
                                        disablePadding onClick={() => innerMenuItem(subItem)} >
                                        <ListItemButton>
                                            <ListItemIcon className="listItem"  >
                                                {subItem.icon}
                                            </ListItemIcon>

                                            <span className="menuTitle">{subItem.title}</span>

                                        </ListItemButton>
                                    </ListItem>
                                    ))
                                }
                            </>
                        )}
                    </div>
                }

                return null

            })}
        </List>
    </>

}

export default Drawer